export const getError = (state) => state.error;
export const getSuccess = (state) => state.success;
export const getIsLoading = (state) => state.isLoading;
export const getDataItem = (state) => state.dataItem;
export const getDataList = (state) => state.dataList;
export const getTotal = (state) => state.total;
export const getId = (state) => state.id;
export default {
    getDataList,
    getTotal,
    getDataItem,
    getError,
    getIsLoading,
    getSuccess,
    getId,
};
